<template>
  <div class="container middle gpxImport">
    <div class="header bottom-shadow">
      <label v-show="!showAdminContent">Import Route from a GPX file</label>
      <label class="add-event-text" v-show="showAdminContent">Add Event from GPX file</label>
    </div>

    <div class="inputs" style="margin-left:50px; margin-right:50px;">
          <div class="input-container">
            <input name="name" type="text" v-model="routeName" placeholder="Route Name">
          </div>
        </div>

    <div class="mid-container">
        <div class="loader" style="padding:20px" v-bind:class="{ 'loader-hide' : gpxUpload.state != 2 }"></div>
        <img v-show="gpxUpload.state == 1" v-bind:src="gpxUpload.previewUrl" style="margin-top: 0px">
        <img v-show="gpxUpload.state == 0" src="../img/gpx_placeholder.png" style="margin-top: 0px">
    </div>

    <div class="bottom-container">

      <div>
				<input type="file" name="gpxFile" id="gpxFile" class="inputfile" v-on:change="gpxFileChanged()" :disabled="isDisabled" />
				<label for="gpxFile"><span id="fileName">{{filename | truncate(40)}}</span></label>
			</div>

      <label id='gpxError' v-show="gpxUpload.error">Something went wrong. Check that the file extension ends in .gpx.</label>
    </div>

    <BottomNav @previousPage="previousPage()" @nextPage="nextPage()" pText="Back" v-bind:pColor="pColor" nText="Create" v-bind:nColor="nColor"/>

  </div>
</template>

<script>

  import firebase from 'firebase'
  import BottomNav from './BottomNav'
  import { mapFields } from 'vuex-map-fields'
  import { store } from '../store/store'
  import moment from 'moment'
  import { userRef } from '../firebase'

  export default {
    name: 'gpxImport',
    title: 'Runner - Gpx Import',
    data() {
      return {
        gpxUpload: {
          state: 0,
          length: 0,
          previewUrl: '',
          routeId: '',
          error: false
        },
        pColor: 'yellow',
        filename: 'Choose a file...',
        routeName: ''
      }
    },
    components: {
       BottomNav
    },
    computed: {
      isDisabled() {
        return this.gpxUpload.state != 2 ? false : true
      },
      nColor() {
        if (this.gpxUpload.state == 1 && this.routeName !== '') {
          return 'green'
        } else {
          return 'gray'
        }
      }
    },
    asyncComputed: {
      showAdminContent() {
        return new Promise((resolve, reject) => {
          firebase.auth().currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Confirm the user is an Admin.
            if (idTokenResult.claims.admin && this.$route.params.addEvent) {
             resolve(true)
           } else {
             resolve(false)
           }
          })
          .catch((error) => {
            console.log(error)
            resolve(false)
          })
        })
      }
    },
    methods: {
      gpxImport() {
        console.log("import")

          this.gpxUpload.error = false

              this.gpxUpload.preview_img = '';
              this.gpxUpload.state = 2;

              var routeId = 'new'

              firebase.auth().currentUser.getIdToken().then((token) => {

                var files = document.getElementById('gpxFile');
                var file = files.files[0];

                let date = moment().format("MM/DD/YYYY HH:MM")

                var formData = new FormData();
                formData.append("route-id", routeId);
                formData.append("gpx", file);
                formData.append("raceGpx", true);
                //formData.append("timestamp", moment().utc("MM/DD/YYYY HH:MM").valueOf() / 1000)
                var xhr = new XMLHttpRequest();

                xhr.open("POST", "https://us-central1-racepeps.cloudfunctions.net/api/process", true);

                xhr.setRequestHeader('Authorization', 'Bearer ' + token);

                xhr.onload = () => {
                    if (xhr.readyState === xhr.DONE) {
                        if (xhr.status === 200) {
                          var result = JSON.parse(xhr.responseText);
                          console.log(result);

                          console.log(this.gpxUpload)

                          this.gpxUpload.state = 1;
                          this.gpxUpload.length = result.length;
                          this.gpxUpload.previewUrl = result.preview_img;
                          this.gpxUpload.routeId = result.id;

                        } else {
                          console.log("Failed to process gpx file");
                          this.gpxUpload.state = 0;
                          this.gpxUpload.error = true;
                        }
                    }
                }

                xhr.onerror = (err) => {
                  console.log("Failed to process gpx file");
                  this.gpxUpload.state = 0;
                  this.gpxUpload.error = true;
                };

                xhr.send(formData);

            });

          },
      previousPage() {
        console.log("cancel")
        if(this.gpxUpload.state != 2) {

          if (this.gpxUpload.routeId != '') {
            console.log("was not empty route")

            this.$store.dispatch('removeRace', this.gpxUpload.routeId).then(() => {
              console.log("route removed, changing page")
              this.$router.replace('menu')
            })
          } else {
            this.$router.replace('menu')
          }
        }
      },
      gpxFileChanged() {

        var fullPath = document.getElementById('gpxFile').value;
        if (fullPath) {
          var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
          var filename = fullPath.substring(startIndex);
          if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
            filename = filename.substring(1);
          }
            console.log(filename)
            this.filename = filename
        } else {
          this.filename = "Choose a file..."
        }

        console.log("gpx file changed");

        if (this.gpxUpload.routeId != '') {
          console.log("was not empty route")
          console.log(this.gpxUpload.routeId)

          this.$store.dispatch('removeRace', this.gpxUpload.routeId).then(function() {
            console.log("Race deleted due to change of file")
          })
        }

        this.gpxUpload.state = 0;
        this.gpxUpload.length = 0;
        this.gpxUpload.previewUrl = '';
        this.gpxUpload.routeId = '';

        this.gpxImport()

    },
    nextPage() {
      if (this.gpxUpload.state === 1) {
        console.log(this.gpxUpload.routeId)
        console.log("nextPage")
        const uid = firebase.auth().currentUser.uid
        var updates = {}
        updates['privateId'] = Math.random().toString(36).substring(2, 15)
        updates['event/name'] = this.routeName
        this.gpxUpload.state = 2

        firebase.database().ref(`/users/${uid}/races/${this.gpxUpload.routeId}/`).update(updates).then(res => {
          this.$router.replace('myraces')
        })
  }
}
}
}

</script>

<style lang="scss" scoped>

  @import '../styles/styles.scss';

  .mid-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 8;
  }

  .bottom-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 2;

    span {
      padding: 10px;
      font-weight: 700;
      background-color: $cyan;
      color: white;
      cursor: pointer;
    }

  }

  .inputfile {
  	width: 0.1px;
  	height: 0.1px;
  	opacity: 0;
  	overflow: hidden;
  	position: absolute;
  	z-index: -1;
  }

  #gpxError {
    color: red;
    font-size: $font-medium;
    text-align: center;
    padding-right: 50px;
    padding-left: 50px;
    margin-top: 30px;
  }

  @media screen and (min-width: 1140px) {

    .gpxImport {
        width: 460px !important;
        height: 650px !important;
    }
  }

</style>
